import {
	createRouter,
	createWebHashHistory
} from 'vue-router';
import Layout from '../layout/index.vue';
import {
	ElMessage
} from 'element-plus';
import {
	h
} from 'vue';

// 引入现有的组件作为临时替代
const Dashboard = () => import('../views/dashboard/index.vue');

// 创建一个只渲染router-view的组件
const RouterViewComponent = {
	render() {
		return h('router-view')
	}
}

const routes = [{
	path: '/',
	redirect: '/login',
},
	{
		path: '/',
		component: Layout,
		children: [{
			path: 'dashboard',
			name: 'Dashboard',
			component: Dashboard,
			meta: {
				title: '数据统计',
				icon: 'Odometer'
			}
		},
		{
			path: 'user',
			name: 'User',
			component: () => import("../views/user/index.vue"),
			meta: {
				title: '用户管理',
				icon: 'User'
			},
			redirect: '/user/list',
			children: [{
				path: 'list',
				name: 'UserList',
				component: () => import('../views/user/list/index.vue'),
				meta: {
					title: '用户列表'
				}
			},
			{
				path: 'merchant',
				name: 'Merchant',
				component: () => import('../views/user/merchant/index.vue'),
				meta: {
					title: '商家管理'
				}
			},
		{
			path: 'agent',
			name: 'Agent',
			component: () => import('../views/user/agent/index.vue'),
			meta: {
				title: '代理商管理'
			}
		},
		{
			path: 'business',
			name: 'Business',
			component: () => import('../views/user/business/index.vue'),
			meta: {
				title: '商家申请审核'
			}
		}]
	},
			{
				path: 'user/profile',
				name: 'UserProfile',
				component: () => import('../views/user/profile/index.vue'),
				meta: {
					title: '个人信息'
				},
				hidden: true
			},
			{
				path: 'product',
				name: 'Product',
				component: () => import('../views/product/index.vue'),
				meta: {
					title: '商品管理',
					icon: 'ShoppingBag'
				}
			},
		{
			path: "order",
			name: "Order",
			meta: {
				title: "订单管理",
				icon: "ShoppingCart"
			},
			component: () => import("../views/order/index.vue"),
			redirect: "/order/list",
			children: [{
				path: 'list',
				name: 'OrderList',
				component: () => import('../views/order/list/index.vue'),
				meta: {
					title: '订单列表'
				}
			},
			{
				path: 'complaint',
				name: 'OrderComplaint',
				component: () => import('../views/order/complaint/index.vue'),
				meta: {
					title: '订单投诉'
				},
				hidden: true
			},
			{
				path: 'review',
				name: 'OrderReview',
				component: () => import('../views/order/review/index.vue'),
				meta: {
					title: '评价管理'
				},
				hidden: true
			},
			{
				path: 'refund',
				name: 'OrderRefund',
				component: () => import('../views/order/refund/index.vue'),
				meta: {
					title: '退款管理'
				}
			},
			{
				path: 'intervention',
				name: 'OrderIntervention',
				component: () => import('../views/order/intervention/index.vue'),
				meta: {
					title: '介入管理'
				}
			}]
		},
			{
				path: 'finance',
				name: 'Finance',
				component: () => import('../views/finance/index.vue'),
				meta: {
					title: '财务管理',
					icon: 'Money'
				},
				redirect: '/finance/transaction',
				children: [{
					path: 'transaction',
					name: 'Transaction',
					component: () => import('../views/finance/transaction/index.vue'),
					meta: {
						title: '交易记录'
					}
				},
					{
						path: 'withdrawal',
						name: 'Withdrawal',
						component: () => import('../views/finance/withdrawal/index.vue'),
						meta: {
							title: '自营收入'
						}
					},
					{
						path: '619',
						name: 'CommissionIncome', // 语义化命名
						component: () => import('../views/finance/619/index.vue'),
						meta: {
							title: '佣金收入'
						}
					},
					{
						path: 'commission-withdrawal',
						name: 'CommissionWithdrawal',
						component: () => import('../views/finance/commission-withdrawal/index.vue'),
						meta: {
							title: '佣金提现'
						}
					}]
			},
	{
		path: "notice",
		name: "Notice",
		component: () => import("../views/notice/index.vue"),
		meta: {
			title: "公告发布",
			icon: "BellFilled"
		}
	},
		{
			path: 'message',
			name: 'Message',
			component: () => import('../views/message/index.vue'),
			meta: {
				title: '消息管理',
				icon: 'ChatDotRound'
			},
			redirect: '/message/chat',
			children: [{
				path: 'chat',
				name: 'Chat',
				component: () => import('../views/message/chat/index.vue'),
				meta: {
					title: '用户聊天'
				}
			},
			{
				path: 'chat-records',
				name: 'ChatRecords',
				component: () => import('../views/message/chat-records/index.vue'),
				meta: {
					title: '聊天记录查询'
				}
			},
			{
				path: 'notification',
				name: 'Notification',
				component: () => import('../views/message/notification/index.vue'),
				meta: {
					title: '系统消息'
				}
			}]
		},
			{
				path: 'setting',
				name: 'Setting',
				component: () => import('../views/setting/index.vue'),
				meta: {
					title: '系统设置',
					icon: 'Setting'
				},
				redirect: '/setting/membership',
				children: [
					{
						path: 'membership',
						name: 'Membership',
						component: () => import('../views/setting/membership/index.vue'),
						meta: {
							title: '会员套餐'
						},
						hidden: true
					},
					{
						path: 'commission',
						name: 'Commission',
						component: () => import('../views/setting/commission/index.vue'),
						meta: {
							title: '推荐返佣设置'
						},
						hidden: true
					},
					{
						path: 'payment-provider',
						name: 'PaymentProvider',
						component: () => import('../views/setting/payment-provider/index.vue'),
						meta: {
							title: '支付服务商配置'
						},
						hidden: true
					},
					{
						path: 'payment-config',
						name: 'PaymentConfig',
						component: () => import('../views/setting/payment-config/index.vue'),
						meta: {
							title: '支付配置'
						},
						hidden: true
					},
					{
						path: 'miniapp-config',
						name: 'MiniappConfig',
						component: () => import('../views/setting/miniapp-config/index.vue'),
						meta: {
							title: '小程序配置'
						},
						hidden: true
					},
					{
						path: 'huifu-config',
						name: 'HuifuConfig',
						component: () => import('../views/setting/huifu-config/index.vue'),
						meta: {
							title: '汇付SDK配置'
						},
						hidden: true
					},
					{
						path: 'auto-reply',
						name: 'AutoReply',
						component: () => import('../views/setting/auto-reply/index.vue'),
						meta: {
							title: '自动回复'
						},
						hidden: true
					},{
						path: 'official-website',
						name: 'OfficialWebsite',
						component: () => import('../views/setting/official-website/index.vue'),
						meta: {
							title: '官网域名'
						},
						hidden: true
					},
					{
						path: 'domain',
						name: 'Domain',
						component: () => import('../views/setting/website-domain/index.vue'),
						meta: {
							title: '官网域名'
						},
						hidden: true
					},
					{
						path: 'website-config',
						name: 'WebsiteConfig',
						component: () => import('../views/setting/website-config/index.vue'),
						meta: {
							title: '网站配置'
						},
						hidden: true
					},
					{
						path: 'agent',
						name: 'SettingAgent',
						component: () => import('../views/setting/agent/index.vue'),
						meta: {
							title: '代理商购买设置'
						},
						hidden: true
					},
					{
						path: 'admin',
						name: 'Admin',
						component: () => import('../views/setting/admin/index.vue'),
						meta: {
							title: '管理员设置'
						},
						hidden: true
					},
					{
						path: 'log-config',
						name: 'LogConfig',
						component: () => import('../views/setting/log-config/index.vue'),
						meta: {
							title: '日志设置'
						},
						hidden: true
					},
					{
						path: 'password',
						name: 'Password',
						component: () => import('../views/setting/password/index.vue'),
						meta: {
							title: '密码修改'
						},
						hidden: true
					},
					{
						path: 'passeagesetting',
						name: 'passeagesetting',
						component: () => import('../views/setting/passeagesetting/index.vue'),
						meta: {
							title: '短信配置'
						},
						hidden: true
					},
					{
						path: 'card',
						name: 'CardSecret',
						component: () => import('../views/setting/card/index.vue'),
						meta: {
							title: '卡密管理'
						},
						hidden: true
					},
					{
						path: 'storagePackage',
						name: 'StoragePackage',
						component: () => import('../views/setting/storagePackage/index.vue'),
						meta: {
							title: '存储套餐'
						},
						hidden: true
					},
					{
						path: 'order-config',
						name: 'OrderConfig',
						component: () => import('../views/setting/order-config/index.vue'),
						meta: {
							title: '订单配置'
						},
						hidden: true
					},
					{
						path: 'payment-code',
						name: 'PaymentCode',
						component: () => import('../views/setting/payment-code/index.vue'),
						meta: {
							title: '收款码配置'
						},
						hidden: true
					},
					{
						path: 'product-autosync',
						name: 'productAutosync',
						component: () => import('../views/setting/product-autosync/index.vue'),
						meta: {
							title: '商品自动转存'
						},
						hidden: true
					}
				]
			},
			{
				path: 'systemConfiguration',
				name: 'SystemConfiguration',
				component: () => import('../views/systemConfiguration/index.vue'),
				meta: {
					title: '三方配置',
					icon: 'Connection'
				},
				redirect: '/systemConfiguration/SMSConfiguration',
				children: [
					{
						path: 'SMSConfiguration',
						name: 'SMSConfiguration',
						component: () => import('../views/systemConfiguration/SMSConfiguration/index.vue'),
						meta: {
							title: '短信配置'
						}
					},
					{
						path: 'cloudStorage',
						name: 'CloudStorage',
						component: () => import('../views/systemConfiguration/cloudStorage/index.vue'),
						meta: {
							title: '云储配置'
						}
					},
					{
						path: 'IdentifyConfiguration',
						name: 'WechatIdentifyConfig', // 语义化命名
						component: () => import('../views/systemConfiguration/IdentifyConfiguration/index.vue'),
						meta: {
							title: '微信识别'
						}
					},
					{
						path: 'WechatConfiguration',
						name: 'WechatConfiguration',
						component: () => import('../views/systemConfiguration/WechatConfiguration/index.vue'),
						meta: {
							title: '微信配置'
						}
					},
					{
						path: 'MiniappAuth',
						name: 'MiniappAuth',
						component: () => import('../views/systemConfiguration/MiniappAuth/index.vue'),
						meta: {
							title: '小程序授权'
						}
					},
					{
						path: 'MarketingDownload',
						name: 'MarketingDownload',
						component: () => import('../views/systemConfiguration/MarketingDownload/index.vue'),
						meta: {
							title: '客户端下载'
						}
					},
					{
						path: 'MarketingFollow',
						name: 'MarketingFollow',
						component: () => import('../views/systemConfiguration/MarketingFollow/index.vue'),
						meta: {
							title: '公众号关注'
						}
					},
					{
						path: 'shop-link-domain',
						name: 'ShopLinkDomain',
						component: () => import('../views/systemConfiguration/shop-link-domain/index.vue'),
						meta: {
							title: '店铺链接域名'
						}
					},
					{
						path: 'shop-popularity',
						name: 'ShopPopularity',
						component: () => import('../views/systemConfiguration/shop-popularity/index.vue'),
						meta: {
							title: '店铺人气配置'
						}
					},
					{
						path: 'domain-list',
						name: 'DomainList',
						component: () => import('../views/systemConfiguration/WechatConfiguration/domain-list/index.vue'),
						meta: {
							title: '配置域名'
						},
						hidden: true
					}
				]
			},
			{
				path: 'image-search-service',
				name: 'ImageSearchService',
				component: () => import('../views/image-search-service/index.vue'),
				meta: {
					title: '搜图服务',
					icon: 'Search'
				}
			},
			{
				path: 'sync-rule',
				name: 'SyncRule',
				component: () => import('../views/sync-rule/index.vue'),
				meta: {
					title: '商品同步规则',
					icon: 'Connection'
				}
			},
			{
				path: 'sync-rule/dashboard',
				name: 'SyncRuleDashboard',
				component: () => import('../views/sync-rule/dashboard.vue'),
				meta: {
					title: '同步规则统计'
				},
				hidden: true
			}
		]
	},
	{
		path: '/login',
		name: 'Login',
		component: () => import('../views/login/index.vue'),
		meta: {
			title: '登录'
		}
	},
	{
		path: '/:catchAll(.*)',
		name: '404',
		component: () => import('../views/error/404.vue'),
		meta: {
			title: '404'
		}
	},
	{
		path: "/officialWebsite",
		name: "officiail-website",
		component: () => import("../views/officialWebsite/index.vue")
	}
];

const router = createRouter({
	history: createWebHashHistory(),
	routes
});

// 全局前置守卫
router.beforeEach((to, from, next) => {
	// 设置页面标题
	document.title = to.meta.title ? `${to.meta.title} - 管理系统` : '管理系统'

	// 添加登录验证
	const token = localStorage.getItem('token')
	// 白名单：不需要登录就可以访问的页面
	const whiteList = ['/login', '/404']

	if (whiteList.includes(to.path)) {
		// 如果在白名单中，直接访问
		if (to.path === '/login' && token) {
			// 如果已经登录且要跳转的页面是登录页，重定向到首页
			next({
				path: '/dashboard'
			})
		} else {
			next()
		}
	} else {
		// 非白名单页面，检查登录状态
		if (!token) {
			// 未登录，跳转到登录页，并记录要访问的路径，以便登录成功后跳转
			ElMessage.warning('您还未登录或登录状态已过期，请先登录')
			next({
				path: '/login',
				query: {
					redirect: to.fullPath
				}
			})
		} else {
			// 已登录
			next()
		}
	}
});

export default router;
